<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de solicitações">
            <template v-slot:actions>
                <rkm-button
                    @click="handleCreate"
                    color="primary"
                    authorize="store-manutencao-solicitacao"
                >
                    Cadastrar solicitação
                </rkm-button>
            </template>

            <rkm-layout-content>
                <ModalSolicitacao ref="ModalSolicitacao" />
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/manutencao/relatorio-solicitacoes/List'
import ModalSolicitacao from '@/components/manutencao/solicitacao/Modal'

export default {
    components: {
        List,
        ModalSolicitacao
    },
    methods: {
        handleCreate() {
            this.$refs.ModalSolicitacao.open()
        }
    },
}
</script>